// GoldZakatTable.js
import React  from 'react';
function GoldZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th > Hasil</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Kewajiban zakat	</td>
          <td>{result.goldZakatDuty === 'yes' ? 'Zakat wajib atas Anda' : 'Zakat tidak wajib atas Anda'}</td>
        </tr>
        <tr >
          <td>Berat emas murni	 </td>
          <td>{result.totalPureGoldWeight} (g) </td>
        </tr>
        <tr >
          <td>Nisab zakat emas</td>
          <td>{result.goldWeightThreshold} (g)</td>
        </tr>
        <tr >
          <td>Jumlah zakat yang wajib dikeluarkan (dari uang)</td>
          <td>{result.moneyZakatAmount} </td>
        </tr>
        <tr >
          <td>Jumlah zakat yang wajib dikeluarkan (dari emas)</td>
          <td>{result.goldZakatAmount} (g)</td>
        </tr>
      </tbody>
    </table>
  );
}
export default GoldZakatTable;